import { Box, Breadcrumbs, Button, Chip, Container, Divider, Link, Stack, TextField, Typography, colors } from '@mui/material';
import React from 'react';
import { fetchWith401Check } from '../../helpers/http';
import Cookies from 'universal-cookie';
import { toast } from 'react-hot-toast';
import { LoadingButton } from '@mui/lab';
import _ from 'lodash';
import ReCAPTCHA from 'react-google-recaptcha';

const CheckRegistrationStatus = () => {
  const [state, setState] = React.useState({});
  const [regs, setRegs] = React.useState({});
  const cookies = new Cookies();

  const [captcha, setCaptcha] = React.useState();

  const [loadingState, setLoadingState] = React.useState({});

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const doCheck = async () => {
    if (!state.regID) return toast.error('Please insert your registration ID');
    if (!captcha) return toast.error('Token not valid');

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      body: JSON.stringify({ id: state.regID, token: captcha }),
    };
    setLoadingState({ ...loadingState, check: true });
    fetchWith401Check(`${API_URL}/auth/register/check`, requestOptions)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function ({ response }) {
        setRegs(response);
      })
      .catch(function (err) {
        return toast.error(err.message);
      })
      .finally(function () {
        setLoadingState({ ...loadingState, check: false });
      });
  };

  const getRegStatus = (status) => {
    if (status === 'new') return 'Menunggu Verifikasi (Waiting for Verification)';
    if (status === 'verified') return 'Telah diverifikasi (Has been verified)';
    if (status === 'rejected') return 'Ditolak (Rejected)';
  };
  return (
    <Stack sx={{ minHeight: '100vh', backgroundColor: colors.cyan[50] }}>
      <Container maxWidth='md' sx={{ minHeight: '100vh', backgroundColor: colors.common.white }}>
        <Breadcrumbs aria-label='breadcrumb' p={2}>
          <Link underline='hover' color='inherit' href='/auth'>
            Auth
          </Link>
          <Link underline='hover' color='inherit' href='/register'>
            Registration
          </Link>
          <Typography color='text.primary'>Check</Typography>
        </Breadcrumbs>
        <Stack spacing={2} p={2}>
          <Stack direction='column' spacing={2}>
            <Typography variant='body2'>Masukkan ID registrasi (enter registration ID)</Typography>
            <TextField onChange={(e) => setState({ ...state, regID: e.currentTarget.value })} value={state.regID} />
          </Stack>
          <Stack direction='row' spacing={1} alignItems='center'>
            <ReCAPTCHA
              size='normal'
              sitekey={process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_SITE_KEY_DEV : process.env.REACT_APP_SITE_KEY}
              onChange={(value) => setCaptcha(value)}
            />
            <Box>
              <LoadingButton loading={loadingState.check} disabled={loadingState.check || !captcha} size='medium' variant='contained' onClick={doCheck}>
                Check
              </LoadingButton>
            </Box>
          </Stack>
        </Stack>

        {!_.isEmpty(regs) && (
          <Stack p={2} spacing={2}>
            <Divider />
            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                Registration status
              </Typography>
              <Chip color={regs.status === 'verified' ? 'primary' : 'error'} variant='outlined' label={getRegStatus(regs.status)} />
            </Stack>

            <Stack spacing={1}>
              <Typography variant='body2'>ID: {regs?.id}</Typography>
              <Typography variant='body2'>First name: {regs?.first_name}</Typography>
              <Typography variant='body2'>Last name: {regs?.last_name}</Typography>
              <Typography variant='body2'>Position: {regs?.position}</Typography>
              <Typography variant='body2'>Phone: {regs?.phone}</Typography>
              <Typography variant='body2'>Organization: {regs?.organization}</Typography>
              <Typography variant='body2'>Email address: {regs?.email_address}</Typography>
              {/* <Typography variant='body2'>
                Attachment:&nbsp;
                <a target='_blank' href={`${API_URL}/download?filename=${regs?.file}`}>
                  Download File
                </a>
              </Typography> */}
            </Stack>
          </Stack>
        )}
      </Container>
    </Stack>
  );
};

export default CheckRegistrationStatus;
